import { ItemList } from '../orm'

class BIGHSVerifyList extends ItemList {
  getEntityKey() {
    return "admin/bi_ghs/verify"
  }

  verify(file_info_ref) {
    return this.saveNewObject({file_info_ref: file_info_ref})
  }
}

export const biGHSVerifyList = new BIGHSVerifyList("bi_ghs_verify_list__default")

class BIGHSUploadList extends ItemList {
  getEntityKey() {
    return "admin/bi_ghs/upload"
  }

  upload(file_info_ref) {
    return this.saveNewObject({file_info_ref: file_info_ref})
  }
}

export const biGHSUploadList = new BIGHSUploadList("bi_ghs_upload_list__default")

class BINutritionalData999VerifyList extends ItemList {
  getEntityKey() {
    return "admin/bi_nutritional_data_999/verify"
  }

  verify(file_info_ref) {
    return this.saveNewObject({file_info_ref: file_info_ref})
  }
}

export const biNutritionalData999VerifyList = new BINutritionalData999VerifyList("bi_nutritional_data_999_verify_list__default")

class BINutritionalData999UploadList extends ItemList {
  getEntityKey() {
    return "admin/bi_nutritional_data_999/upload"
  }

  upload(file_info_ref) {
    return this.saveNewObject({file_info_ref: file_info_ref})
  }
}

export const biNutritionalData999UploadList = new BINutritionalData999UploadList("bi_nutritional_data_999_upload_list__default")
